module.exports = __webpack_public_path__ + "static/media/iconPreinscriptionActive.722ac1c6.svg";